import { UITypes } from "@/components/BookmarkButton/BookmarkButton.interface";
import { TagProps } from "shared/components/Tag/Tag.interface";
import { WysiwygEntities } from "shared/components/WysiwygText/interface";

import {
  AuthorInterface,
  MetaDataInterface,
  SlugInterface,
} from "../Common/interface";

interface ImageInterface {
  alt?: string;
  title?: string;
  caption?: string;
  versions: {
    original: {
      url: string;
    };
  };
}

type TileSizeVariant = "medium" | "small";

export enum ArticleType {
  open = "tekst open",
  premium = "tekst premium",
}

export interface SlideInterface {
  id: string;
  title: string;
  index?: string | number;
  body: string;
  videoUrl?: string;
  image?: ImageInterface;
}

export interface ArticleInterface {
  initialData: {
    id: string;
    title: string;
    mainPicture: ImageInterface;
    tags?: TagProps[];
    subtags?: TagProps[];
    entities: WysiwygEntities;
    lead: string;
    body: string;
    gallery?: SlideInterface[];
    authors: AuthorInterface[];
    publishedAt: string;
    relatedArticle?: {
      title: string;
      slug: SlugInterface;
    };
    matureContent?: boolean;
    schemaMetaData?: any;
    bookmarked?: boolean;
    headMetaData?: MetaDataInterface;
    articleType: ArticleType;
    slug?: string;
  };
  related: ArticleTileProps[];
}

export interface ArticleTileProps {
  id: number;
  title: string;
  slug: string;
  publishedAt: string;
  image: string;
  tags: TagProps[];
  tag: TagProps;
  author: AuthorInterface;
  gallery: boolean;
  bookmarked: boolean;
  variant?: TileSizeVariant;
  className?: string;
  from?: string;
  index?: number;
  sneakPeak?: string;
  uiType?: UITypes;
  readingTime?: number;
}

export interface ArticleFeedInterface {
  initialData: {
    [key: string]: ArticleTileProps;
  };
}
